module.exports = __webpack_public_path__ + "static/assets/0472a37be1cbd481ce5f41c6d2e04786.svg";